<template>
  <div data-v-abca6e38="" data-v-2ac6a5fc="" class="assets-wrap  s11ss">
    <div data-v-abca6e38="" class="assets">
      <div data-v-abca6e38="" class="content">
        <div data-v-abca6e38="" class="list">
          <div data-v-abca6e38="" class="t">
            剩余领取次数{{ userredpacket.sendnums }}<span style="padding-left: 10px"></span>已领取次数{{ userredpacket.acquirednum }}
            <span style="font-size: 10px; color: #999; font-weight: 100; padding-left: 10px"> </span>
            <!-- <a @click="getwelfare" data-v-abca6e38="" class="link">抢红包</a> -->
            <a @click="$parent.goNav('/hongbao')" data-v-abca6e38="" class="link">抢红包</a>
          </div>

          <div data-v-73a82902="" data-v-3acb7497="" infinite-scroll-disabled="busy" infinite-scroll-distance="10" class="c" style="margin-top:10px">
            <div data-v-73a82902="" class="flex-group" v-for="(item, index) in redpacketList" :key="index">
              <div data-v-73a82902="" class="item" style="flex: 1; margin-right: 20px">
                <p data-v-73a82902="" class="txt-bold">
                  充值金额：{{ item.money }} <span data-v-73a82902=" " style="float: right; color: #999">红包金额：{{ item.redpacketmoney }}</span>
                </p>
                <p>充值时间： {{ item.created_at }}</p>
                <p data-v-73a82902="" class="status">充值时间： {{ item.created_at }}</p>
              </div>
            </div>

            <div data-v-abca6e38="" class="empty" v-if="redpacketList.length == 0" style="margin-top:10px">
              <div data-v-abca6e38="" class="icon-empty"></div>
              <p data-v-abca6e38="">暂无记录</p>
            </div>
          </div>
          <el-pagination v-if="redpacketShowData.total"  style="margin: 20px 0 0px 120px;background:none" @current-change="getredpacket" :current-page.sync="page" :page-size="10" layout="prev, pager, next" :total="redpacketShowData.total"></el-pagination>
          <div style="height:120px"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'welfare',
  data() {
    return {
      redpacketList: [],
      page: 1,
      redpacketShowData: {},
      userredpacket: {},
    };
  },
  created() {
    let that = this;
    that.getredpacket();
    that.getuserredpacket();
  },
  methods: {
    getwelfare() {
      let that = this;
      if (that.userredpacket.sendnums < 1) {
        that.$parent.showTost(0, '您的剩余次数不足！');

        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/douserredpacket', {})
        .then(res => {
          console.log(res);

          that.$parent.showTost(0, res.message);
          that.$parent.hideLoading();
          that.getredpacket();
          that.getuserredpacket();
        })
        .catch(() => {
          that.$parent.showTost(0, '服务器异常，请稍后再试');
          that.$parent.hideLoading();
        });
    },
    getuserredpacket() {
      let that = this;
      that.$parent.showLoading();
      let info = {
        page: that.page,
      };
      that.$apiFun.get('/api/userredpacket', info).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.userredpacket = res.data;
        }
        that.$parent.hideLoading();
      });
    },
    // 获取红包记录
    getredpacket() {
      let that = this;
      that.$parent.showLoading();
      let info = {
        page: that.page,
      };
      that.$apiFun.post('/api/redpacket', info).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.redpacketList = res.data.data;
          that.redpacketShowData = res.data;
        }
        that.$parent.hideLoading();
      });
    },
  },
  mounted() {
    let that = this;
    window.addEventListener('scroll', this.Scroll, true);
    // window.onscroll = function () {

    // };
  },
  updated() {
    let that = this;
    //展开资产详情
    // $('.arrow-down').click(function () {
    //   $('.list-wrap').toggleClass('list-wrap-extend').find('.list').slideToggle(200);
    //   $(this).toggleClass('arrow-up');
    // });
  },
  beforeDestroy() {
    let that = this;
    if (that.daoTime) {
      clearInterval(that.daoTime);
    }
    that.daoTime = null;
    window.removeEventListener('scroll', this.Scroll, true);
  },
};
</script>

<style lang="scss" scoped>
@import '../../../static/css/chunk-080bb754.bc0cc7c7.css';
.leftSpan {
  margin-right: 20px;
}
.hg {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.hg input {
  flex: 1;
  height: 20px;
  line-height: 20px;
  outline: 0;
  background: #fff;
  border: 0;
  font-size: 14px;
  color: #333;
  padding-left: 6px;
}
.types {
  color: rgb(72, 32, 0);
  display: block;
  border-radius: 6px;
  text-align: center;
  padding: 0px 9px;
  font-size: 12px;
  // background: #333;
  color: #999;
  margin-right: 10px;
}
.types.active {
  background-image: linear-gradient(90deg, rgb(254, 203, 77), rgb(255, 223, 144));
  color: #482000;
}
.popup-background[data-v-710c460e] {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
}
.assetDetails .content .list .tab a[data-v-abca6e38][data-v-05a2a38e],
.assets .content .list .tab a[data-v-abca6e38][data-v-05a2a38e] {
  margin-right: 6px;
}

.assetDetails .content .list .c[data-v-3acb7497],
.assets .content .list .c[data-v-3acb7497] {
  background: #222;
  border-radius: 4px;
  padding: 0 15px;
  position: relative;
}
.assetDetails .content .list .c[data-v-73a82902],
.assets .content .list .c[data-v-73a82902] {
  background: #222;
  border-radius: 4px;
  padding: 0 15px;
  position: relative;
}
.assetDetails .content .list .c .flex-group[data-v-73a82902],
.assets .content .list .c .flex-group[data-v-73a82902] {
  height: 68px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border-bottom: 1px solid rgba(58, 58, 58, 0.5);
}

.assetDetails .flex-group[data-v-73a82902],
.assets .flex-group[data-v-73a82902] {
  position: relative;
}
.assetDetails .content .list .c .flex-group .item[data-v-73a82902],
.assets .content .list .c .flex-group .item[data-v-73a82902] {
  display: inline-block;
  position: relative;
}
.assetDetails .content .list .c .flex-group .item .checkbox[data-v-73a82902],
.assets .content .list .c .flex-group .item .checkbox[data-v-73a82902] {
  width: 20px;
  height: 20px;
  position: relative;
}
.assetDetails .content .list .c .flex-group .item .checkbox input[data-v-73a82902],
.assets .content .list .c .flex-group .item .checkbox input[data-v-73a82902] {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  border: 0;
  opacity: 0;
  margin: 0;
  z-index: 100;
}
.assetDetails .content .list .c .flex-group .item .checkbox .check[data-v-73a82902],
.assets .content .list .c .flex-group .item .checkbox .check[data-v-73a82902] {
  width: 100%;
  height: 100%;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAABCCAYAAAGUUzB+AAAAAXNSR0IArs4c6QAABYZJREFUeAHtW0toHVUYntzc5HbR7nRTBLuwLYjiIpAIKi5cSMFSWgsScOEquUnMxtS12blosopJbrLqQgjSx0ah1J20gjcmC0ELURcqYjauNAtvcpP4fYf5Ts7Jfacz05twBobzz3n8j2/+8/xnoiizq1gsTufakZZxpXZUinpUi1aIVloqlWryVOanIyMj+37OwZMpq8f+oEoUtcQmiwp7e3ufuEq59Ojo6H8GrLGxsTf29/ffcgvxvLG0tLRi0aTNPT09j3HfdivWo9H4Au7h5eVl2z6CuJ/qVW4njxoauNqR3oghTWyJeaPGbn6XMSHarnqd0Gi7Yes3c3lbySHoQLhvOllHJ42jgFsRKi2CzWwul9tqxY7uDZeowlP7TF2Y8F2rRofLJycnC2j3MOrUfpcR2z6xXwQGbQybLur16AAiQMR1eWJi4vl6ALWdR5/GPdNug/Hx8RfUhw7GfbRG5hQ0OtOKUV9f36dzc3MV1vMYqCEY3QH9rp6TSjGGbOEexvLgK5enVcIZmMqY1V51KyVJ853t7Oz8Rp7e7EnLhW2SApvxgrwZyVSvIvSzzRolXQYUbpAnFJmSEvTvlnND0oqQH53YKpGGgHZ5BiWEVEAiICEElHaPT3BiabYHk8ZJppyGyY+zqTuB7WBlnS8UCqc0xSYp1OWFyfI2ZF3P5/ODCwsL31slVAlj+UPQr+s5jRRD9RCm89U0eB+ZZw0SOER4B1Ct4D59ZK6NG97F7Hn9cLGnBN6V8QtWgrOu4P75cIOjPMPpT4PXJRj2Ysx7DLu0knhZJbTAgLeem5+f/10Vkk4hhzvDIShlFTHjROyMEXtGmgrQoHjpWAYq3OOaS4MVe8Ns2l0zlilFuKrigjrK8YSFhJZbpLO48DoeQ45Z0ed2d3cHsxB6WAZex33lYdxovVFR5SRTyLVrWvlEkvw75hWUEGQBiYCEEFAafCIgIQSUBp8ISAgBpcEnLBJYZh0Em5SbQQq5NkCW6+/vv0eZ2iVnIN+IgBLDWOyaJV5Oy3wseH/MSgGFA6DEMGUax+QuGZoVuGVPWxHG2Xi2DQWqOmi320AocBOK3EBhpbe39yWcG/yatELY7DCWMUW+2OdY2ZZgAXbkg9i8lkmneD2CAmbDJRmeEsqcnp4+tbm5eRWoXFTek6Qw7F+gu7q4uMgDmJqrrhI1teIMvs9qtUq0nsOrO/u0Nk6N9KOxAO4v6PUnjqJW1eka1XfzmwIRuwjDIKkeYbkKpUQ/AjAf8YyuEf+6QKizqhE7LTzgMzArpdFxJSfJlOM/vLcI3T/kCCjeeJ7BQdXHelbqAUEPQKNvcedZAY3uYGJ5vxMXE+NuStmlt7e3P4dd5tgQdlVxv+YepFogeHaJPvZlDEAFb/9i2gdoWYPFSRNesiEPwVhy2Zu7YsT+RgVzgAsQzh+XLtApmHGX+SV+4Vvw+Gfo8WYlAbe5JhDgMisnFQQaT9toI2naTNtJGyBQYOdq0ImcppN5t16ujbK9KzY93QBYACJ+CwGIAITfIYNHBI8IHuEjEDzCxyOMEcEjgkf4CASP8PEIY0TwiOARPgLBI3w8whjhegQDI8IHdBofnop9V6SujTiu+4dKGY9gKEwa4ujqkuiTmro24iTbBH16aeza2tofAwMDL4Pk17rPgj6zvr7+NctO2hVHga/Edt1FsIdRYf+Hs/ijYIX3yvg4+M3jHtzRi2TIolKpfIPnoTjPi0bbAI8aINynv3KVVcbn2u8d12BP/JPdFw4AjODZz8JlZA0QKiAgoOcwmJjwn/LBhB8z/4B8Rp3t57wqf5opB0HodxY6vAL9zEf50gf5VdCT7gf6KmPaEAi3UhwO/ADM3oaAYzGrQNct6PoAL+uWwnquTYFugMD/V4UWCZ3LxIUAAAAASUVORK5CYII=)
    no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.assetDetails .content .list .c .flex-group .item .bankcard[data-v-73a82902],
.assets .content .list .c .flex-group .item .bankcard[data-v-73a82902] {
  width: 36px;
  height: 36px;
  display: block;
}

.icon_weixin[data-v-73a82902] {
  background-position: -72.8px 0;
}
.icon_weixin[data-v-73a82902],
.icon_zhifubao[data-v-73a82902] {
  width: 36.4px;
  height: 36.4px;
  background-image: url(/static/image/deposit_icons.669e4d3f.png);
  background-repeat: no-repeat;
  background-size: 259px 109.2px;
}
.assetDetails .content .list .c .flex-group .item p[data-v-73a82902],
.assets .content .list .c .flex-group .item p[data-v-73a82902] {
  font-size: 14px;
  color: #999;
  line-height: 22px;
}
.assetDetails .content .list .c .flex-group .item p.txt-bold[data-v-73a82902],
.assets .content .list .c .flex-group .item p.txt-bold[data-v-73a82902] {
  color: #fff;
}

.assetDetails .content .list .c .flex-group .item p[data-v-73a82902],
.assets .content .list .c .flex-group .item p[data-v-73a82902] {
  font-size: 14px;
  color: #999;
  line-height: 22px;
}
.assetDetails .content .list .c .flex-group .item p.payType[data-v-73a82902],
.assetDetails .content .list .c .flex-group .item p .requestId[data-v-73a82902],
.assets .content .list .c .flex-group .item p.payType[data-v-73a82902],
.assets .content .list .c .flex-group .item p .requestId[data-v-73a82902] {
  font-size: 12px;
  line-height: 16px;
}
.assetDetails .content .list .c .flex-group .item p[data-v-73a82902],
.assets .content .list .c .flex-group .item p[data-v-73a82902] {
  font-size: 14px;
  color: #999;
  line-height: 22px;
}
.assetDetails .content .list .c .flex-group .item p[data-v-73a82902],
.assets .content .list .c .flex-group .item p[data-v-73a82902] {
  font-size: 14px;
  color: #999;
  line-height: 22px;
}
.assetDetails .content .list .c .flex-group .item p[data-v-73a82902],
.assets .content .list .c .flex-group .item p[data-v-73a82902] {
  font-size: 14px;
  color: #999;
  line-height: 22px;
}
.assetDetails .list-wrap .list .flex-group[data-v-abca6e38][data-v-05a2a38e],
.assets .list-wrap .list .flex-group[data-v-abca6e38][data-v-05a2a38e] {
  height: auto;
  border-bottom: 1pxsolidrgba (0, 0, 0, 0.15);
  width: 33%;
  padding: 0 15px;
  display: inline-block;
}

.btne {
  background-image: linear-gradient(90deg, rgb(254, 203, 77), rgb(255, 223, 144));
  color: rgb(72, 32, 0);
  margin: 6px auto;
  display: block;
  border-radius: 6px;
  text-align: center;
  width: 65%;
  font-size: 12px;
}
.assetDetails .list-wrap .list .flex-group .item p[data-v-abca6e38][data-v-05a2a38e],
.assets .list-wrap .list .flex-group .item p[data-v-abca6e38][data-v-05a2a38e] {
  font-size: 12px;
  color: #fff;
  line-height: 22px;
}
.assetDetails .banner[data-v-abca6e38],
.assets .banner[data-v-abca6e38] {
  padding: 59px 0 0px;
}
.qiehuan {
  color: #fecb4d;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  border: 1px solid #fecb4d;
  padding: 4px 0;
  width: 100px;
  position: absolute;
  top: 20px;
  right: 5px;
}
.qiehuan img {
  width: 18px;
  margin-right: 4px;
}
.assetDetails .content .list .c,
.assets .content .list .c {
  padding: 0 6px !important;
}
.assetDetails .content .list .c .flex-group,
.assets .content .list .c .flex-group {
  height: 88px !important;
}

</style>



// WEBPACK FOOTER //
// src/components/main/welfare.vue